;( function( $, undefined )
{

    $.fn.SiteCatalystCommonSetup = function( siteCat )
    {
        if( siteCat.$mainContainer.hasClass( 'thread' ) )
        {
            var boardName = $( '#topic-select-title' ).find( 'a' ).text();
            var subject   = $( 'meta[property="og:title"]' ).attr( 'content' );
            var prop20    = boardName.toLowerCase() + ':' + $.fn.SiteCatalyst.slugify( subject );

            $.fn.SiteCatalyst.globals.thread = {
                subject   : subject,
                prop20    : prop20,
                boardName : boardName
            };
        }
    };

    $.fn.SiteCatalystCommon = function( siteCat )
    {
        var that = siteCat;

        $( '.popular-topics-actions' ).on( 'click', 'a', function( e )
        {
            that.track( 'Browse All Topics clicked', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:browse-all-topics:null:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( '#nav-browse-topics-link' ).click( function()
        {
            that.track( 'Navigation link clicked: Browse Topics', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:browse topics:nav:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( '#btn-forgot-password' ).click( function()
        {
            that.track( 'Navigation link clicked: Forgot your Password', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:forgot your password:nav:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $('.meganav__menu').on('click', 'a', function (e) {
            var label = $.trim($(this).text()).toLowerCase().replace(' ', '-');
            that.track( 'Meganav link clicked', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:' + label + ':nav:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        });

        $( '#nav-recent-discussions-link' ).click( function()
        {
            that.track( 'Navigation link clicked: Recent Discussions', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:recent discussions:nav:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( '#nav-get-help-link' ).click( function()
        {
            that.track( 'Navigation link clicked: Get help', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:get help:nav:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( 'li.icon-messages' ).find( 'a' ).click( function()
        {
            that.track( 'Benefits link clicked: PSN Friends', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:psn friends:benefits:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( 'li.icon-solutions' ).find( 'a' ).click( function()
        {
            that.track( 'Benefits link clicked: Get Help', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:get help:benefits:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( 'li.icon-calendar' ).find( 'a' ).click( function()
        {
            that.track( 'Benefits link clicked: Events and Competitions', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:event competitions:benefits:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( 'li.icon-games' ).find( 'a' ).click( function()
        {
            that.track( 'Benefits link clicked: MPV or Beta Tester', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:mvp beta tester:benefits:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $( '#sign-up-get-started-now' ).click( function()
        {
            that.track( 'Benefits link clicked: Get started now', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:get started now:benefits:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } ).next().children( 'a' ).click( function()
        {
            that.track( 'Benefits link clicked: Sign in', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'link:sign in:benefits:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $('#signup-register-menu').find('.login-link').click( function()
        {
            that.track( 'Navigation: Sign in', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:sign in:nav:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        $('#signup-register-menu').find('.registration-link').click( function()
        {
            that.track( 'Navigation: Register', {
                type   : that.eventType.other,
                vars   : {
                    prop49 : 'button:register:nav:' + that.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );

        var trackSendPrivateMessageUserAvatarClick = function()
        {
            $( '.message-author-detail' ).find( '.send-message' ).on( 'click', function()
            {
                that.track( 'User avatar: send message', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:send message:user avatar:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackPopularTopicsClick = function()
        {
            $( '#popular-topics-all' ).find( 'li' ).children().on( 'click', function()
            {
                var topic    = $( this ).children( '.topic' ).data( 'image-name' ).toLowerCase()
                  , position = $( this ).parent().index() + 1;

                that.track( 'Popular topics: click', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:popular topic ' + topic + ':pos-' + position + ':' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );

            $( '#popular-topics-support .popular-topics-carousel' ).find( 'li' ).children().on( 'click', function()
            {
                var topic    = $( this ).children( '.topic' ).data( 'image-name' ).toLowerCase()
                  , position = $( this ).parent().index() + 1;

                that.track( 'Support topics: click', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:support topic ' + topic + ':pos-' + position + ':' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );

            $( '#popular-topics-support' ).find( '.column.left' ).find( 'a' ).on( 'click', function( e )
            {
                var $clone = $( this ).clone();
                $clone.find( 'span' ).remove();

                var thread   = $clone.text().replace( /[^a-zA-Z0-9\s]/g, '' ).toLowerCase(),
                    position = $( this ).children( 'span' ).text().replace( '.', '' );

                that.track( 'Support topics: click', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : ' link:support thread ' + thread + ':pos-' + position + ':' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackMessagesItemClick = function()
        {
            $( '#messages-list' ).find( 'a' ).on( 'click', function()
            {
                that.track( 'Messages menu: item clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:messages menu item:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackContextualNav = function()
        {
            $( '.pdc6-contextual-nav' ).find( 'ul a' ).on( 'click', function()
            {
                var name = $( this ).data( 'name' );

                that.track( 'Contextual nav: ' + name, {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:contextual nav ' + name + ':null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackUserAvatarClick = function()
        {
            $( '#logged-in-user' ).find( 'a:first-child' ).on( 'click', function()
            {
                that.track( 'Navigation: avatar clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:navigation user avatar:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackUserOnlineId = function()
        {
            $( '#logged-in-user' ).find( 'a:last-child' ).on( 'click', function()
            {
                that.track( 'Navigation: online-id clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:navigation user online-id:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackMessagesIcon = function()
        {
            $( '#message-alerts-button' ).on( 'click', function()
            {
                that.track( 'Messages menu: icon clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:messages menu icon:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackMessagesViewAll = function()
        {
            $( '#message-page-link' ).on( 'click', function()
            {
                that.track( 'Messages menu: view all clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:messages menu view all:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackNotificationTypes = function()
        {
            $( '#notification-list' ).find( 'a:not(.cta)' ).on( 'click', function()
            {
                that.track( 'Notifications menu: item clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:notifications menu ' + $( this ).parent().data( 'notification-type' ) + ':null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );

        };

        var trackNotificationsBell = function()
        {
            $( '#alerts-button' ).on( 'click', function()
            {
                that.track( 'Notifications menu: icon clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:notifications menu icon:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackNotificationsViewAll = function()
        {
            $( '#notifications-page-link' ).on( 'click', function()
            {
                that.track( 'Notifications menu: view all clicked', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:notifications menu view all:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        trackSendPrivateMessageUserAvatarClick();
        trackPopularTopicsClick();

        trackNotificationsBell();
        trackNotificationsViewAll();
        trackNotificationTypes();

        trackMessagesIcon();
        trackMessagesViewAll();
        trackMessagesItemClick();

        trackUserAvatarClick();
        trackUserOnlineId();
        trackContextualNav();
    };

} )( jQuery );
